import { useSnackbar } from 'notistack';
import { useIntl } from 'react-intl';
interface INotificationOptions {
  message?: React.ReactNode;
  content?: React.ReactNode;
  languageKey?:string,
  languageKeyError?:any,
  resultType?:string;
}

export const useApiValidationSnackbar = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { formatMessage } = useIntl();

  const notifySuccess = (customize?: INotificationOptions,languageKey?:INotificationOptions) => {
    enqueueSnackbar(formatMessage({ id:`component.message.${languageKey}`}), {
      variant:'success',
      content: customize?.content,
    });
  };
  const ErrorMessage = (customize?: INotificationOptions,languageKeyError?:INotificationOptions) => {
    enqueueSnackbar(formatMessage({ id:`component.message.${languageKeyError}`}), {
      variant:'error',
      content: customize?.content,
    });
  };
  return {notifySuccess,ErrorMessage}
};
